import { Typography } from 'seagull';
import { CoverCreditCardFeesSelector } from "../../../../components/agreement-controllers/CoverCreditCardFeesSelector";
import { useStore } from "../../../../contexts";
import EditableTableCell from "../EditableTableCell/EditableTableCell";
import { getUICompanyName } from "../EditDraftsTable.utils";
import { jsx as _jsx } from "react/jsx-runtime";
export default function CreditCardProcessingFeesCell(_ref) {
  let {
    draft,
    index,
    contact,
    onOpenModal,
    isDisabled,
    disabledTooltip
  } = _ref;
  const draftLabel = getUICompanyName(draft, contact);
  const userInfo = useStore(state => state.userInfo);
  const worksAt = userInfo === null || userInfo === void 0 ? void 0 : userInfo.business();
  const isPaidByClient = !draft.coverCreditCardFees();
  const onClick = () => onOpenModal({
    renderContent: _ref2 => {
      let {
        draft,
        setDraft
      } = _ref2;
      return {
        title: 'Credit card processing fees',
        testId: "edit-credit-card-processing-fees-modal",
        onSubmit: defaultBehavior => {
          defaultBehavior();
        },
        content: /*#__PURE__*/_jsx(CoverCreditCardFeesSelector, {
          value: draft.coverCreditCardFees(),
          onChange: value => setDraft(draft.setCoverCreditCardFees(value)),
          vendorBusinessName: worksAt === null || worksAt === void 0 ? void 0 : worksAt.name,
          clientBusinessName: contact === null || contact === void 0 ? void 0 : contact.companyName(),
          testId: "edit-credit-card-processing-fees-modal"
        })
      };
    }
  });
  return /*#__PURE__*/_jsx(EditableTableCell, {
    testId: "edit-credit-card-processing-fees-".concat(index),
    onClick: onClick,
    isDisabled: isDisabled,
    disabledTooltip: disabledTooltip,
    children: /*#__PURE__*/_jsx(Typography, {
      testId: "credit-card-processing-fees-".concat(index),
      children: isPaidByClient ? "Paid by ".concat(draftLabel || 'the client') : "Paid by ".concat((worksAt === null || worksAt === void 0 ? void 0 : worksAt.name) || 'the service provider')
    })
  });
}